import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import Dropzone from 'react-dropzone'
var $ = require('jquery')

class PicFSUpload extends Component {
	componentDidMount = () => {
		$(this.refs.Multiple).on('change', this.handeFileSelect)
		$(this.refs.Single).on('change', this.handeFileSelect)
	};

	handeFileSelect = (evt) => {
		this.props.onFilesSelected(evt.target.files)
	};

	select = () => {
		if (this.props.multiple) {
			$(this.refs.Multiple).trigger('click');
		} else {
			$(this.refs.Single).trigger('click');
		}
	};

	onDrop(acceptedFiles, rejectedFiles) {
		this.props.onFilesSelected(acceptedFiles)
	}

	render() {
		let accept = this.props.accept ? this.props.accept : 'image/*'
		return (
			<div
				style={this.props.style}
				onClick={this.select}>
				<Dropzone
					multiple={this.props.multiple}
					accept={accept}
					style={this.props.style}
					onDrop={this.onDrop.bind(this)}>
					{this.props.children}
				</Dropzone>
			</div>
		);
	}
}

PicFSUpload.propTypes = {
	onFilesSelected: PropTypes.func.isRequired,
	multiple: PropTypes.bool
};

export default Radium(PicFSUpload)


// WEBPACK FOOTER //
// ./src/App/Common/picFSUpload.jsx